import { either, isEmpty, isNil } from 'ramda';

export const isBlank = either(isNil, isEmpty);
